module.exports = {
      id: "Dpe-usage",
      viewBox: "0 0 24 14",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/product/sprite.svg#Dpe-usage",
      toString: function () {
        return this.url;
      }
    }